<template>
  <div>
      <v-btn color="primary" small fab @click.native="dialog = true, getProducts(); getProducts_discount();"><v-icon dark>add</v-icon></v-btn>
    <v-dialog v-model="dialog" persistent max-width="800px">


      <v-card>
        <v-card-title>
          <span class="headline">Kies een Product</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
            <v-flex xs12 sm2 md12>
         

              <v-data-table
              v-model="selectedproduct"
              :headers="headers_products"
              :items="loadedProducts"
              :pagination.sync="pagination"
               hide-actions
        
              >
              <template slot="headers_products" slot-scope="props">
                <tr>
                  <th>
                   
                  </th>
                  <th
                    v-for="(header_products, index) in props.headers_products"
                    :key="index">
                    
                    {{ header_products.text }}
                  </th>
                </tr>
              </template>
              <template slot="items" slot-scope="props">
                <tr @click="props.expanded = !props.expanded" >
                   
                  <td>
                    <v-checkbox :active="props.selected" @click="props.selected = !props.selected; computeSelectedProducts(); "
                      :input-value="props.selected"
                      primary
                      hide-details
                    ></v-checkbox>
                  </td>
                <td class="text-xs-right">  <v-list-tile-avatar>
                <img :src="company[1] + props.item.field_product_afbeelding">
              </v-list-tile-avatar></td>
                  <td class="text-xs-left" >{{ props.item.title }}</td> 
                  <td class="text-xs-left">{{ props.item.field_product_prijs }}</td>
                  
                  
                      </tr>
                    </template>
                    <template slot="expand" slot-scope="props">
            <v-card flat>
              <v-card-text>{{ props.item.field_product_omschrijving }}</v-card-text>
            </v-card>
          </template>

            </v-data-table>

    
                  
            <v-radio-group v-if="selectedproduct.length !== 0" v-model="$store.state.selected_discount_product" :mandatory="false" column>
                  <v-radio
                    label="Geen"
                    @click.native="DeSelectedProducts();"
                    :value="$store.state.radioboxen.noradio"
                  ></v-radio>
              <template v-for="(acties,index3) in loadedProducts_discounts" >
                    <v-radio
                      :key="index3"
                      :label="acties.title"
                      :value="acties"
                      @click.native="computeSelectedProducts_discount();"
                    ></v-radio>
                </template>
              </v-radio-group>
         

<!-- @click="$store.state.selectedWithTreatment = treatment; $store.state.withTreatmentboolean = true;" -->

        </v-flex>
            </v-layout>
          </v-container>
         
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          
          <v-btn v-if="selectedproduct.length == 0" color="blue darken-1" dark  @click.native="dialog = false">Sluiten</v-btn>
          <v-btn v-else color="blue darken-1" dark  @click.native="dialog = false">Verder</v-btn> 

        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<style scoped>
.fromprice {
  text-decoration-line: line-through;
}
</style>

<script>
import accounting from "accounting";
import axios from "axios";

export default {
  data: () => ({
    dialog: false,
    company: ["Hair & Beauty Company", "http://www.hairbeautycompany.nl"],
    loadedProducts: [],
    loadedProducts_discounts: [],
    pagination: { sortBy: "name" },
    value: 0,
    selectedproduct: [],
    selected_discount: [],
    headers_products: [
      { text: "", value: "" },
      { text: "", value: "" },
      {
        text: "Products",
        align: "left",
        value: "name"
      },
      { text: "Orginele prijs", value: "Orginele prijs" }
    ]
  }),

  methods: {
    resetCheckbox: function(value) {
      this.selectedproduct = value;
    },

    getProducts: function() {
      var vm = this;
      const config = {
        mode: "cors",
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Access-Control-Allow-Methods": "GET, POST, PATCH, PUT, DELETE, OPTIONS",
          "Access-Control-Allow-Headers": "Origin, Content-Type, X-Auth-Token"
        }
      };

      axios
        .get("https://www.hairbeautycompany.nl/api/products?_format=json", config)

        .then(function(response) {
          console.log(response);

          vm.loadedProducts = response.data;
        })
        .catch(function(error) {
          console.log(error);
        });
    },

    getProducts_discount: function() {
      let checkmembership;
      if (this.$store.state.membershipdiscount == false) {
        checkmembership = "";
      } else {
        checkmembership = "/abo";
      }

      var vm = this;
      const config = {
        mode: "cors",
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Access-Control-Allow-Methods": "GET, POST, PATCH, PUT, DELETE, OPTIONS",
          "Access-Control-Allow-Headers": "Origin, Content-Type, X-Auth-Token"
        }
      };

      axios
        .get(
          "https://www.hairbeautycompany.nl/api/actie/products" + checkmembership + "?_format=json",
          config
        )

        .then(function(response) {
          console.log(response);
          console.log(
            "https://www.hairbeautycompany.nl/api/actie/products" +
              checkmembership +
              "?_format=json"
          );

          vm.loadedProducts_discounts = response.data;
        })
        .catch(function(error) {
          console.log(error);
        });
    },

    DeSelectedProducts: function() {
      // this.$store.state.ProductCalc.TitleProduct = []
      // this.$store.state.ProductCalc.prijsproduct = 0
      this.$store.state.selectedProduct_discount.Product_discount_result = null;
      this.selectedproduct = [];
      this.$store.state.ProductCalc.TitleProduct = null;
      this.$store.state.ProductCalc.prijsproduct = null;
      this.$store.state.selectedProduct_discount.Product_discount_name = null;
    },

    computeSelectedProducts: function() {
      //Array foreach and convert to number with ForEach function. += operator for sum
      var sumTitleProduct = [];
      var sumprijsproduct = 0;

      this.selectedproduct.forEach(function(element) {
        console.log("test each " + element.field_product_prijs);

        // sumTitleProduct  += `${element.title} `

        sumTitleProduct.push(element.title);
        sumprijsproduct += Number(element.field_product_prijs); //Sums the selected prices

        console.log(sumTitleProduct);
        console.log(sumprijsproduct);
      });
      this.$store.state.ProductCalc.TitleProduct = sumTitleProduct;
      this.$store.state.ProductCalc.prijsproduct = sumprijsproduct; //store the prices to VUEX
    },

    computeSelectedProducts_discount: function() {
      // Bereken actie met Euros of Percentage

      let discountcalc; //Euros or Percentage?
      if (this.$store.state.selected_discount_product.field_korting_type == "Bedrag") {
        let bedrag;

        bedrag = Number(this.$store.state.selected_discount_product.field_korting_in_euro);

        this.$store.state.selectedProduct_discount.Product_discount_result = Number(
          this.$store.state.selected_discount_product.field_korting_in_euro
        );

        this.$store.state.selectedProduct_discount.Product_discount_name =
          this.$store.state.selected_discount_product.title +
          " " +
          this.$store.state.selected_discount_product.field_merken_actie; //Resultaat met gekozen Merk actie
      } else {
        let percentage;
        let naamdiscountresultaat;

        percentage =
          Number(this.$store.state.selected_discount_product.field_korting_in_percentage) /
          100 *
          this.$store.state.ProductCalc.prijsproduct; //Percentage uitrekenen

        this.$store.state.selectedProduct_discount.Product_discount_result = percentage; //Schijft de uiteindelijke percentage berekening naar de Vuex state.

        this.$store.state.selectedProduct_discount.Product_discount_name =
          this.$store.state.selected_discount_product.title +
          " " +
          this.$store.state.selected_discount_product.field_merken_actie; //Resultaat met gekozen Merk actie
      }
    },

    changeSort(column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending;
      } else {
        this.pagination.sortBy = column;
        this.pagination.descending = false;
      }
    }
  },

  computed: {}
};
</script>